<template>
	<div class="container h-100">
	    <div class="row">
	          <div class="col-md-8 mx-auto">
	                <div class="box-page border rounded w-100">
	               
                      <h2 class="mb-5 font-weight-bold text-center">Sign in</h2>
                      <a @click="signinGreat('mentor')" class="text-white btn-greatgrowth opct cr-pointer d-block font-weight-bold">
	                      SIGN IN WITH GreatGrowth
	                  </a>
						<div class="my-4 d-flex  align-items-center">
							<hr class="w-50 bd-gray">
							<span class="mx-3">or</span>
							<hr class="w-50 bd-gray">
						</div>
                      <a @click="signinGreat('ticket')" class="text-white btn-tickets opct cr-pointer d-block mb-5 font-weight-bold">
	                      SIGN IN WITH TICKETS
	                  </a>
	                </div>
	          </div>
	    </div>
	</div>
</template>
<script>
import { HTTPReview } from '@/axios.js'
	export default{
		methods:{
			signinGreat(name){
				//window.open('http://localhost:8081/signin-mentor','mentor','height=400,width=600');
				this.$router.push('/signin-mentor/'+name)
			},
			signout(){
	          setTimeout(() => {
	            window.localStorage.clear();
	          }, 100);
	          this.$store.commit("clearlogin");
	          window.localStorage.removeItem("review");
	          this.$router.push("/");
	        },
		},
		created(){
			this.signout()
		},
		computed:{
			user(){
				return this.$store.state.user
			}
		},
		watch:{
			user(){
				if(this.user != ''){
					this.$router.push('/review-list')
				}
			}
		}
	}
</script>
<style scoped>
	.box-page{
		padding: 20px 80px;
		position: relative;
		top:50%;
		
	}
	.opct{
		opacity: 0.6;
	}
	.opct:hover{
		opacity: 1;
	}
</style>